module.exports = __webpack_public_path__ + "img/medal.e3ff5901.png";